import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO
        title="404 - Siden blev ikke fundet"
        description="Den side, du leder efter hos Caspers Træservice, findes desværre ikke eller er blevet flyttet."
      />

      <section className="py-24 sm:py-32 bg-[#FBF9F5] flex items-center justify-center min-h-[70vh]">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 text-center space-y-6">
          <div className="w-20 h-20 rounded-2xl bg-[#EFE8DC] text-[#1E4231] flex items-center justify-center text-4xl mx-auto shadow-inner border border-[#D8CEBD]">
            <i className="fa-solid fa-tree-deciduous text-[#D9691E]" aria-hidden="true" />
          </div>

          <span className="text-xs font-bold uppercase tracking-widest text-[#D9691E] bg-[#D9691E]/10 px-3.5 py-1.5 rounded-full inline-block">
            Fejl 404
          </span>

          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#12281D] tracking-tight">
            Siden blev ikke fundet
          </h1>

          <p className="text-base sm:text-lg text-[#526D5F] leading-relaxed max-w-md mx-auto">
            Det ser ud til, at siden du leder efter, er blevet fældet eller flyttet. Brug linksene herunder til at finde det rigtige sted.
          </p>

          <div className="pt-4 flex flex-wrap items-center justify-center gap-4">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-[#1E4231] hover:bg-[#285741] text-white px-6 py-3.5 rounded-xl font-bold text-sm shadow-md transition-all whitespace-nowrap"
            >
              <i className="fa-solid fa-house" aria-hidden="true" />
              <span>Gå til forsiden</span>
            </Link>

            <Link
              to="/traefaeldning"
              className="inline-flex items-center gap-2 bg-white hover:bg-[#F2ECE1] text-[#14291E] border border-[#D5CDBD] px-6 py-3.5 rounded-xl font-bold text-sm shadow-sm transition-all whitespace-nowrap"
            >
              <span>Se træfældning</span>
            </Link>

            <Link
              to="/kontakt"
              className="inline-flex items-center gap-2 bg-[#D9691E] hover:bg-[#C25B15] text-white px-6 py-3.5 rounded-xl font-bold text-sm shadow-md transition-all whitespace-nowrap"
            >
              <span>Kontakt os</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
